var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.024,
    height: 34.935,
    viewBox: "0 0 159.024 34.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12555",
    "data-name": "Group 12555",
    transform: "translate(20380.679 194.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85145",
    "data-name": "Path 85145",
    d: "M17.191,23.495H15.749V15.1q0-.993.12-2.422h-.034a7.862,7.862,0,0,1-.369,1.211l-4.2,9.6h-.7L6.356,13.963a7.279,7.279,0,0,1-.369-1.281H5.952q.069.75.069,2.44v8.373H4.63V11H6.536l3.778,8.713a11.124,11.124,0,0,1,.558,1.5h.06q.43-1.2.592-1.533L15.38,11h1.812V23.495",
    transform: "translate(-20385.309 -202.32)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85146",
    "data-name": "Path 85146",
    d: "M57.556,22.161H56.148V13.239h1.408v8.922m.24-12.12a.887.887,0,0,1-.275.667.945.945,0,0,1-1.305.009.9.9,0,0,1-.266-.675.908.908,0,0,1,.262-.649.871.871,0,0,1,.657-.274.916.916,0,0,1,.927.924",
    transform: "translate(-20421.668 -200.986)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85147",
    "data-name": "Path 85147",
    d: "M74.025,31.236a4.52,4.52,0,0,1-2.413.627,4.183,4.183,0,0,1-2.159-.562,3.846,3.846,0,0,1-1.49-1.59,4.944,4.944,0,0,1-.532-2.309,5.009,5.009,0,0,1,1.249-3.555,4.33,4.33,0,0,1,3.327-1.342,4.407,4.407,0,0,1,2.035.453v1.464a3.575,3.575,0,0,0-2.1-.7,2.8,2.8,0,0,0-2.219.989,3.771,3.771,0,0,0-.854,2.557,3.56,3.56,0,0,0,.811,2.466,2.776,2.776,0,0,0,2.177.906,3.521,3.521,0,0,0,2.164-.767v1.359",
    transform: "translate(-20429.801 -210.47)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85148",
    "data-name": "Path 85148",
    d: "M100.427,24.318a1.869,1.869,0,0,0-2.593.606,4.175,4.175,0,0,0-.584,2.322v4.548H95.842V22.871H97.25V24.71h.034a3.154,3.154,0,0,1,.9-1.459,2.057,2.057,0,0,1,1.4-.536,2.279,2.279,0,0,1,.841.122v1.481",
    transform: "translate(-20449.928 -210.619)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85149",
    "data-name": "Path 85149",
    d: "M119.45,27.2a3.982,3.982,0,0,0-.734-2.579,2.558,2.558,0,0,0-2.1-.9,2.685,2.685,0,0,0-2.147.919,3.857,3.857,0,0,0-.79,2.592,3.662,3.662,0,0,0,.794,2.5,2.71,2.71,0,0,0,2.142.9,2.566,2.566,0,0,0,2.1-.889,3.93,3.93,0,0,0,.73-2.553m1.442-.052a4.853,4.853,0,0,1-1.189,3.42,4.122,4.122,0,0,1-3.19,1.294A4.033,4.033,0,0,1,113.4,30.6a4.689,4.689,0,0,1-1.163-3.315,4.941,4.941,0,0,1,1.193-3.5,4.268,4.268,0,0,1,3.288-1.285,3.9,3.9,0,0,1,3.065,1.242,4.929,4.929,0,0,1,1.108,3.4",
    transform: "translate(-20461.543 -210.47)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85150",
    "data-name": "Path 85150",
    d: "M151.232,29.258a2.319,2.319,0,0,1-.88,1.882,3.569,3.569,0,0,1-2.34.723,4.283,4.283,0,0,1-2.181-.54V29.789a3.516,3.516,0,0,0,2.284.854q1.674,0,1.674-1.246a1.1,1.1,0,0,0-.326-.823,6.233,6.233,0,0,0-1.485-.858,4.407,4.407,0,0,1-1.648-1.085,2.511,2.511,0,0,1,.395-3.385,3.326,3.326,0,0,1,2.224-.741,4.168,4.168,0,0,1,1.88.418v1.438a3.257,3.257,0,0,0-1.992-.636,1.713,1.713,0,0,0-1.12.349,1.108,1.108,0,0,0-.425.9,1.212,1.212,0,0,0,.326.91,4.821,4.821,0,0,0,1.348.754,4.853,4.853,0,0,1,1.76,1.133,2.212,2.212,0,0,1,.507,1.49",
    transform: "translate(-20485.342 -210.47)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85151",
    "data-name": "Path 85151",
    d: "M174.829,27.2a3.982,3.982,0,0,0-.734-2.579,2.558,2.558,0,0,0-2.1-.9,2.685,2.685,0,0,0-2.147.919,3.857,3.857,0,0,0-.79,2.592,3.662,3.662,0,0,0,.794,2.5,2.71,2.71,0,0,0,2.142.9,2.566,2.566,0,0,0,2.1-.889,3.93,3.93,0,0,0,.73-2.553m1.442-.052a4.853,4.853,0,0,1-1.189,3.42,4.122,4.122,0,0,1-3.19,1.294A4.033,4.033,0,0,1,168.78,30.6a4.69,4.69,0,0,1-1.163-3.315,4.941,4.941,0,0,1,1.193-3.5,4.268,4.268,0,0,1,3.288-1.285,3.9,3.9,0,0,1,3.065,1.242,4.929,4.929,0,0,1,1.108,3.4",
    transform: "translate(-20500.773 -210.47)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85152",
    "data-name": "Path 85152",
    d: "M204.171,9.339a1.855,1.855,0,0,0-.936-.235q-1.477,0-1.477,1.891v1.377h2.061v1.211h-2.061v7.711H200.35V13.582h-1.494V12.371h1.494V10.925a3.066,3.066,0,0,1,.79-2.2,2.642,2.642,0,0,1,2.009-.836,2.723,2.723,0,0,1,1.022.157V9.339",
    transform: "translate(-20522.906 -200.117)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85153",
    "data-name": "Path 85153",
    d: "M222.153,25.673a2.665,2.665,0,0,1-1.322.288q-2.3,0-2.3-2.631v-5.28h-1.511V16.838h1.511V14.66l1.408-.462v2.64h2.215v1.211h-2.215v5.036a2.086,2.086,0,0,0,.3,1.276,1.208,1.208,0,0,0,1,.379,1.482,1.482,0,0,0,.91-.287v1.22",
    transform: "translate(-20535.773 -204.585)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85154",
    "data-name": "Path 85154",
    d: "M60.321,73.822q0-2.483-2.885-2.483H55.744v5.123h1.511a3.377,3.377,0,0,0,2.275-.684,2.448,2.448,0,0,0,.79-1.956m1.511-.078A3.748,3.748,0,0,1,60.6,76.667a4.645,4.645,0,0,1-3.233,1.111H55.744v4.731H54.3V70.015h3.383a4.411,4.411,0,0,1,3.061.98,3.515,3.515,0,0,1,1.086,2.749",
    transform: "translate(-20420.498 -244.126)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85155",
    "data-name": "Path 85155",
    d: "M87.043,86.146l-2.129.3a3.12,3.12,0,0,0-1.528.527,1.488,1.488,0,0,0-.438,1.2,1.346,1.346,0,0,0,.472,1.076,1.793,1.793,0,0,0,1.211.405,2.238,2.238,0,0,0,1.73-.749,2.676,2.676,0,0,0,.683-1.873v-.889m1.408,4.513H87.043V89.265h-.034a2.939,2.939,0,0,1-2.7,1.612,2.889,2.889,0,0,1-2.035-.7,2.434,2.434,0,0,1-.764-1.886q0-2.492,2.9-2.91L87.043,85q0-2.265-1.812-2.265a4.312,4.312,0,0,0-2.868,1.089V82.365a4.264,4.264,0,0,1,1.322-.571,6,6,0,0,1,1.666-.274q3.1,0,3.1,3.337v5.8",
    transform: "translate(-20439.77 -252.277)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85156",
    "data-name": "Path 85156",
    d: "M117.5,83.332a1.869,1.869,0,0,0-2.593.606,4.175,4.175,0,0,0-.584,2.322v4.548H112.92V81.886h1.408v1.838h.034a3.154,3.154,0,0,1,.9-1.459,2.058,2.058,0,0,1,1.4-.536,2.276,2.276,0,0,1,.841.122v1.481",
    transform: "translate(-20462.025 -252.425)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85157",
    "data-name": "Path 85157",
    d: "M138.674,84.687a2.666,2.666,0,0,1-1.322.288q-2.3,0-2.3-2.631v-5.28h-1.511V75.852h1.511V73.674l1.408-.462v2.64h2.215v1.211h-2.215V82.1a2.084,2.084,0,0,0,.3,1.276,1.207,1.207,0,0,0,1,.379,1.483,1.483,0,0,0,.91-.287v1.22",
    transform: "translate(-20476.633 -246.392)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85158",
    "data-name": "Path 85158",
    d: "M165.2,90.659h-1.408V85.571q0-2.831-2.043-2.832a2.221,2.221,0,0,0-1.739.8,2.971,2.971,0,0,0-.7,2.034v5.088H157.9V81.737h1.408v1.481h.034a3.15,3.15,0,0,1,2.885-1.7,2.655,2.655,0,0,1,2.211.958,4.283,4.283,0,0,1,.76,2.718v5.463",
    transform: "translate(-20493.891 -252.277)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85159",
    "data-name": "Path 85159",
    d: "M194.451,85.345a2.987,2.987,0,0,0-.588-1.921,1.982,1.982,0,0,0-1.61-.684,2.253,2.253,0,0,0-1.674.714,3.358,3.358,0,0,0-.876,1.891h4.748m1.442,1.211h-6.208a3.352,3.352,0,0,0,.786,2.3,2.721,2.721,0,0,0,2.082.8,4.269,4.269,0,0,0,2.722-.976v1.333a4.973,4.973,0,0,1-3.057.863,3.659,3.659,0,0,1-2.936-1.233,5.076,5.076,0,0,1-1.056-3.411,5.489,5.489,0,0,1,.528-2.418,4.077,4.077,0,0,1,1.455-1.695,3.708,3.708,0,0,1,2.061-.6,3.309,3.309,0,0,1,2.666,1.128,4.74,4.74,0,0,1,.957,3.158v.749",
    transform: "translate(-20515.375 -252.277)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85160",
    "data-name": "Path 85160",
    d: "M224.666,83.332a1.869,1.869,0,0,0-2.593.606,4.176,4.176,0,0,0-.584,2.322v4.548h-1.408V81.886h1.408v1.838h.035a3.154,3.154,0,0,1,.9-1.459,2.056,2.056,0,0,1,1.4-.536,2.278,2.278,0,0,1,.842.122v1.481",
    transform: "translate(-20537.941 -252.425)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1625",
    "data-name": "Line 1625",
    y2: 34.935,
    transform: "translate(-20306.289 -194.281)",
    fill: "none",
    stroke: "#222c3a",
    strokeMiterlimit: 10,
    strokeWidth: 0.564
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85161",
    "data-name": "Path 85161",
    d: "M291.351,40.006a1.494,1.494,0,0,1-.555,1.232,2.341,2.341,0,0,1-1.509.447,3.184,3.184,0,0,1-.785-.113,2.13,2.13,0,0,1-.616-.243v-.863a2.147,2.147,0,0,0,.694.4,2.335,2.335,0,0,0,.807.16q1.2,0,1.2-.932a.951.951,0,0,0-.256-.668,4.724,4.724,0,0,0-1.05-.737,3.7,3.7,0,0,1-1.076-.824,1.594,1.594,0,0,1,.243-2.147,2.132,2.132,0,0,1,1.423-.464,2.563,2.563,0,0,1,1.223.221v.815a1.983,1.983,0,0,0-1.262-.382,1.324,1.324,0,0,0-.846.26.823.823,0,0,0-.325.681,1.091,1.091,0,0,0,.1.494,1.229,1.229,0,0,0,.33.369,6.8,6.8,0,0,0,.785.49,4.021,4.021,0,0,1,1.154.867,1.447,1.447,0,0,1,.33.937",
    transform: "translate(-20585.977 -221.41)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85162",
    "data-name": "Path 85162",
    d: "M300.269,35.283a.446.446,0,0,1-.139.334.489.489,0,0,1-.659,0,.469.469,0,0,1,.664-.664.443.443,0,0,1,.134.325h0m-.121,6.033h-.711V36.874h.711v4.441",
    transform: "translate(-20592.918 -221.148)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85163",
    "data-name": "Path 85163",
    d: "M305.76,41.188h-.711V34.614h.711v6.575",
    transform: "translate(-20596.381 -221.023)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85164",
    "data-name": "Path 85164",
    d: "M312.983,40.032l-1.769,4.441h-.7l-1.678-4.441h.785l1.128,3.222a3.436,3.436,0,0,1,.147.625h.022a2.821,2.821,0,0,1,.139-.6l1.184-3.244h.746",
    transform: "translate(-20598.676 -224.308)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85165",
    "data-name": "Path 85165",
    d: "M324.323,42.263h-3.136a1.669,1.669,0,0,0,.395,1.149,1.4,1.4,0,0,0,1.054.395,2.177,2.177,0,0,0,1.375-.486v.664a2.539,2.539,0,0,1-1.544.429,1.864,1.864,0,0,1-1.483-.611,2.512,2.512,0,0,1-.533-1.7,2.7,2.7,0,0,1,.265-1.2,2.05,2.05,0,0,1,.737-.846,1.893,1.893,0,0,1,1.041-.3,1.672,1.672,0,0,1,1.344.564,2.319,2.319,0,0,1,.486,1.57v.373h0m-.729-.6a1.453,1.453,0,0,0-.3-.954,1,1,0,0,0-.811-.343,1.146,1.146,0,0,0-.846.356,1.66,1.66,0,0,0-.442.941h2.4",
    transform: "translate(-20605.717 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85166",
    "data-name": "Path 85166",
    d: "M335.241,40.632a.951.951,0,0,0-1.31.3,2.044,2.044,0,0,0-.295,1.154v2.264h-.711V39.912h.711v.915h.017a1.554,1.554,0,0,1,.455-.724,1.044,1.044,0,0,1,.707-.269,1.161,1.161,0,0,1,.425.061v.737",
    transform: "translate(-20613.279 -224.187)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85167",
    "data-name": "Path 85167",
    d: "M351.249,38.548a3.323,3.323,0,0,1-.416,1.678,2.819,2.819,0,0,1-1.184,1.119,3.822,3.822,0,0,1-1.756.39h-1.644V35.517h1.717q3.283,0,3.283,3.031h0m-.763.017q0-2.39-2.537-2.39h-.971v4.9h.924a2.631,2.631,0,0,0,1.908-.655,2.473,2.473,0,0,0,.677-1.856",
    transform: "translate(-20621.355 -221.57)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85168",
    "data-name": "Path 85168",
    d: "M364.4,44.306h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.186q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542v-.729a2.141,2.141,0,0,1,.668-.282,3.028,3.028,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.728.728,0,0,0-.221.594.673.673,0,0,0,.238.538.921.921,0,0,0,.612.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932v-.442",
    transform: "translate(-20630.232 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85169",
    "data-name": "Path 85169",
    d: "M374.422,42.407a1.362,1.362,0,0,1-.668.143q-1.162,0-1.162-1.31V38.612h-.763v-.6h.763V36.925l.711-.23v1.314h1.119v.6H373.3v2.507a1.038,1.038,0,0,0,.152.638.619.619,0,0,0,.507.187.756.756,0,0,0,.46-.143v.607",
    transform: "translate(-20636.863 -222.285)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85170",
    "data-name": "Path 85170",
    d: "M383.39,44.306h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.186q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542v-.729a2.142,2.142,0,0,1,.668-.282,3.029,3.029,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.728.728,0,0,0-.221.594.673.673,0,0,0,.238.538.921.921,0,0,0,.612.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932v-.442",
    transform: "translate(-20641.744 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85171",
    "data-name": "Path 85171",
    d: "M401.452,37.373a1.856,1.856,0,0,1-.624,1.457,2.364,2.364,0,0,1-1.631.551h-.82v2.355h-.729V35.517h1.709a2.234,2.234,0,0,1,1.544.49,1.726,1.726,0,0,1,.551,1.366h0m-.763.039q0-1.236-1.457-1.236h-.854v2.55h.763a1.73,1.73,0,0,0,1.149-.338,1.216,1.216,0,0,0,.4-.976",
    transform: "translate(-20652.514 -221.57)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85172",
    "data-name": "Path 85172",
    d: "M410.748,41.188h-.711V34.614h.711v6.575",
    transform: "translate(-20660.023 -221.023)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85173",
    "data-name": "Path 85173",
    d: "M418.078,44.306h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.186q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542v-.729a2.141,2.141,0,0,1,.668-.282,3.028,3.028,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.727.727,0,0,0-.221.594.673.673,0,0,0,.239.538.921.921,0,0,0,.612.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932v-.442",
    transform: "translate(-20662.771 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85174",
    "data-name": "Path 85174",
    d: "M428.1,42.407a1.362,1.362,0,0,1-.668.143q-1.162,0-1.162-1.31V38.612h-.763v-.6h.763V36.925l.711-.23v1.314H428.1v.6h-1.119v2.507a1.037,1.037,0,0,0,.152.638.619.619,0,0,0,.507.187.756.756,0,0,0,.46-.143v.607",
    transform: "translate(-20669.402 -222.285)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85175",
    "data-name": "Path 85175",
    d: "M435.925,35.091a.948.948,0,0,0-.473-.117q-.746,0-.746.941V36.6h1.041v.6h-1.041v3.838h-.711V37.2h-.755v-.6h.755v-.72a1.514,1.514,0,0,1,.4-1.093,1.345,1.345,0,0,1,1.015-.416,1.394,1.394,0,0,1,.516.078v.642",
    transform: "translate(-20674.09 -220.876)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85176",
    "data-name": "Path 85176",
    d: "M445.034,42.068a2.4,2.4,0,0,1-.6,1.7,2.094,2.094,0,0,1-1.609.642,2.063,2.063,0,0,1-1.574-.625,2.327,2.327,0,0,1-.586-1.652,2.429,2.429,0,0,1,.6-1.739,2.168,2.168,0,0,1,1.661-.642,1.979,1.979,0,0,1,1.548.62,2.422,2.422,0,0,1,.56,1.691h0m-.729.026a1.953,1.953,0,0,0-.373-1.284,1.294,1.294,0,0,0-1.058-.447,1.362,1.362,0,0,0-1.084.46,1.892,1.892,0,0,0-.4,1.288,1.82,1.82,0,0,0,.4,1.249,1.388,1.388,0,0,0,1.084.447,1.3,1.3,0,0,0,1.063-.442,1.935,1.935,0,0,0,.369-1.271",
    transform: "translate(-20678.59 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85177",
    "data-name": "Path 85177",
    d: "M456.873,40.632a.951.951,0,0,0-1.31.3,2.044,2.044,0,0,0-.295,1.154v2.264h-.711V39.912h.711v.915h.017a1.553,1.553,0,0,1,.455-.724,1.044,1.044,0,0,1,.707-.269,1.161,1.161,0,0,1,.425.061v.737",
    transform: "translate(-20687.012 -224.187)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85178",
    "data-name": "Path 85178",
    d: "M468.712,44.306H468v-2.55a1.884,1.884,0,0,0-.23-1.067.862.862,0,0,0-.763-.325.953.953,0,0,0-.776.416,1.593,1.593,0,0,0-.317.993v2.533H465.2V41.669q0-1.305-1.01-1.305a.935.935,0,0,0-.772.395,1.606,1.606,0,0,0-.3,1.015v2.533h-.711V39.865h.711v.7h.017a1.5,1.5,0,0,1,1.375-.811,1.329,1.329,0,0,1,.781.243,1.25,1.25,0,0,1,.481.681,1.584,1.584,0,0,1,1.474-.924q1.466,0,1.466,1.813v2.737",
    transform: "translate(-20691.77 -224.14)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85179",
    "data-name": "Path 85179",
    d: "M291.351,72.427a1.494,1.494,0,0,1-.555,1.232,2.341,2.341,0,0,1-1.509.447,3.185,3.185,0,0,1-.785-.113,2.13,2.13,0,0,1-.616-.243v-.863a2.147,2.147,0,0,0,.694.4,2.336,2.336,0,0,0,.807.16q1.2,0,1.2-.932a.951.951,0,0,0-.256-.668,4.724,4.724,0,0,0-1.05-.737,3.7,3.7,0,0,1-1.076-.824,1.594,1.594,0,0,1,.243-2.147,2.132,2.132,0,0,1,1.423-.464,2.563,2.563,0,0,1,1.223.221v.815a1.983,1.983,0,0,0-1.262-.382,1.324,1.324,0,0,0-.846.26.823.823,0,0,0-.325.681,1.091,1.091,0,0,0,.1.494,1.229,1.229,0,0,0,.33.369,6.794,6.794,0,0,0,.785.49,4.02,4.02,0,0,1,1.154.867,1.447,1.447,0,0,1,.33.937",
    transform: "translate(-20585.977 -241.064)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85180",
    "data-name": "Path 85180",
    d: "M300.269,67.7a.446.446,0,0,1-.139.334.489.489,0,0,1-.659,0,.469.469,0,0,1,.664-.664.443.443,0,0,1,.134.325h0m-.121,6.033h-.711V69.3h.711v4.441",
    transform: "translate(-20592.918 -240.802)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85181",
    "data-name": "Path 85181",
    d: "M305.76,73.609h-.711V67.035h.711v6.575",
    transform: "translate(-20596.381 -240.675)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85182",
    "data-name": "Path 85182",
    d: "M312.983,72.453l-1.769,4.441h-.7l-1.678-4.441h.785l1.128,3.222a3.436,3.436,0,0,1,.147.625h.022a2.821,2.821,0,0,1,.139-.6l1.184-3.244h.746",
    transform: "translate(-20598.676 -243.96)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85183",
    "data-name": "Path 85183",
    d: "M324.323,74.684h-3.136a1.669,1.669,0,0,0,.395,1.149,1.4,1.4,0,0,0,1.054.395,2.177,2.177,0,0,0,1.375-.486v.664a2.539,2.539,0,0,1-1.544.429,1.864,1.864,0,0,1-1.483-.611,2.512,2.512,0,0,1-.533-1.7,2.7,2.7,0,0,1,.265-1.2,2.051,2.051,0,0,1,.737-.846,1.893,1.893,0,0,1,1.041-.3,1.672,1.672,0,0,1,1.344.564,2.319,2.319,0,0,1,.486,1.57v.373h0m-.729-.6a1.453,1.453,0,0,0-.3-.954,1,1,0,0,0-.811-.343,1.146,1.146,0,0,0-.846.356,1.66,1.66,0,0,0-.442.941h2.4",
    transform: "translate(-20605.717 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85184",
    "data-name": "Path 85184",
    d: "M335.241,73.053a.951.951,0,0,0-1.31.3,2.044,2.044,0,0,0-.295,1.154v2.264h-.711V72.333h.711v.915h.017a1.554,1.554,0,0,1,.455-.724,1.044,1.044,0,0,1,.707-.269,1.161,1.161,0,0,1,.425.061v.737",
    transform: "translate(-20613.279 -243.841)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85185",
    "data-name": "Path 85185",
    d: "M351.249,70.969a3.323,3.323,0,0,1-.416,1.678,2.819,2.819,0,0,1-1.184,1.119,3.822,3.822,0,0,1-1.756.39h-1.644V67.938h1.717q3.283,0,3.283,3.031h0m-.763.017q0-2.39-2.537-2.39h-.971v4.9h.924a2.631,2.631,0,0,0,1.908-.655,2.473,2.473,0,0,0,.677-1.856",
    transform: "translate(-20621.355 -241.224)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85186",
    "data-name": "Path 85186",
    d: "M364.4,76.727h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.187q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542V72.6a2.142,2.142,0,0,1,.668-.282,3.028,3.028,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.728.728,0,0,0-.221.594.673.673,0,0,0,.238.538.921.921,0,0,0,.612.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932V74.48",
    transform: "translate(-20630.232 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85187",
    "data-name": "Path 85187",
    d: "M374.422,74.828a1.362,1.362,0,0,1-.668.143q-1.162,0-1.162-1.31V71.033h-.763v-.6h.763V69.346l.711-.23V70.43h1.119v.6H373.3V73.54a1.038,1.038,0,0,0,.152.638.619.619,0,0,0,.507.186.756.756,0,0,0,.46-.143v.607",
    transform: "translate(-20636.863 -241.937)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85188",
    "data-name": "Path 85188",
    d: "M383.39,76.727h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.187q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542V72.6a2.143,2.143,0,0,1,.668-.282,3.029,3.029,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.728.728,0,0,0-.221.594.673.673,0,0,0,.238.538.921.921,0,0,0,.612.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932V74.48",
    transform: "translate(-20641.744 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85189",
    "data-name": "Path 85189",
    d: "M401.361,74.157h-.807l-.655-1.739h-2.641l-.62,1.739h-.807l2.377-6.219h.755l2.4,6.219h0m-1.7-2.4-.976-2.646a3.694,3.694,0,0,1-.1-.421h-.017a2.045,2.045,0,0,1-.1.421l-.967,2.646h2.155",
    transform: "translate(-20651.412 -241.224)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85190",
    "data-name": "Path 85190",
    d: "M415.64,76.727h-.711V74.194q0-1.409-1.032-1.409a1.132,1.132,0,0,0-.88.4,1.463,1.463,0,0,0-.351,1.01v2.533h-.711V72.286h.711v.737h.017a1.6,1.6,0,0,1,1.457-.846,1.343,1.343,0,0,1,1.115.477,2.1,2.1,0,0,1,.386,1.353v2.719",
    transform: "translate(-20661.186 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85191",
    "data-name": "Path 85191",
    d: "M427.28,76.727h-.711v-.694h-.017a1.613,1.613,0,0,1-2.394.455,1.21,1.21,0,0,1-.386-.941q0-1.24,1.466-1.449l1.331-.187q0-1.128-.915-1.128a2.2,2.2,0,0,0-1.449.542V72.6a2.142,2.142,0,0,1,.668-.282,3.028,3.028,0,0,1,.841-.139q1.566,0,1.566,1.661v2.888h0m-.711-2.246-1.076.152a1.572,1.572,0,0,0-.772.265.727.727,0,0,0-.221.594.673.673,0,0,0,.238.538.921.921,0,0,0,.611.2,1.132,1.132,0,0,0,.872-.373,1.316,1.316,0,0,0,.347-.932V74.48",
    transform: "translate(-20668.35 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85192",
    "data-name": "Path 85192",
    d: "M436.775,73.609h-.711V67.035h.711v6.575",
    transform: "translate(-20675.801 -240.675)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85193",
    "data-name": "Path 85193",
    d: "M444.041,72.453,442,77.605q-.546,1.375-1.535,1.375a1.756,1.756,0,0,1-.464-.052V78.29a1.28,1.28,0,0,0,.416.078.873.873,0,0,0,.811-.638l.356-.846-1.735-4.432h.794l1.2,3.417.091.338h.026q.017-.1.087-.325l1.262-3.43h.737",
    transform: "translate(-20678.094 -243.96)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85194",
    "data-name": "Path 85194",
    d: "M453.654,74.828a1.362,1.362,0,0,1-.668.143q-1.162,0-1.162-1.31V71.033h-.763v-.6h.763V69.346l.711-.23V70.43h1.119v.6h-1.119V73.54a1.037,1.037,0,0,0,.152.638.619.619,0,0,0,.507.186.756.756,0,0,0,.46-.143v.607",
    transform: "translate(-20684.893 -241.937)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85195",
    "data-name": "Path 85195",
    d: "M460.717,67.7a.446.446,0,0,1-.139.334.489.489,0,0,1-.659,0,.469.469,0,0,1,.664-.664.443.443,0,0,1,.134.325h0m-.121,6.033h-.711V69.3h.711v4.441",
    transform: "translate(-20690.18 -240.802)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85196",
    "data-name": "Path 85196",
    d: "M467.968,76.523a2.309,2.309,0,0,1-1.219.312,2.163,2.163,0,0,1-1.093-.278,1.949,1.949,0,0,1-.75-.794,2.433,2.433,0,0,1-.269-1.149,2.476,2.476,0,0,1,.629-1.769,2.21,2.21,0,0,1,1.683-.668,2.25,2.25,0,0,1,1.028.226v.729a1.821,1.821,0,0,0-1.058-.347,1.424,1.424,0,0,0-1.123.494,1.858,1.858,0,0,0-.429,1.271,1.762,1.762,0,0,0,.408,1.227,1.419,1.419,0,0,0,1.1.451,1.8,1.8,0,0,0,1.093-.382v.677",
    transform: "translate(-20693.123 -243.794)",
    fill: "#222c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85197",
    "data-name": "Path 85197",
    d: "M477.783,75.539a1.147,1.147,0,0,1-.447.937,1.812,1.812,0,0,1-1.18.36,2.189,2.189,0,0,1-1.1-.269V75.8a1.792,1.792,0,0,0,1.154.425q.846,0,.846-.62a.536.536,0,0,0-.165-.408,3.08,3.08,0,0,0-.75-.429,2.246,2.246,0,0,1-.833-.538,1.24,1.24,0,0,1,.2-1.687,1.7,1.7,0,0,1,1.123-.369,2.131,2.131,0,0,1,.95.208V73.1a1.661,1.661,0,0,0-1.006-.317.882.882,0,0,0-.568.173.551.551,0,0,0-.213.447.606.606,0,0,0,.165.455,2.5,2.5,0,0,0,.681.373,2.451,2.451,0,0,1,.889.564,1.091,1.091,0,0,1,.256.742",
    transform: "translate(-20699.438 -243.794)",
    fill: "#222c3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.d57ad7f28e202f7dd0a8da8db008b396.svg";
export { ForwardRef as ReactComponent };